import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const Banner = () => {
  const bannerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Create a timeline for the initial logo and text animations
      const tl = gsap.timeline({ defaults: { duration: 1, ease: "power3.out" } });

      // Wobble-In Logo Animation
      tl.from(".logo", {
        scale: 0.3,
        rotation: -30,
        opacity: 0,
        duration: 1,
        ease: "power2.out"
      })
      .to(".logo", {
        rotation: 15,
        duration: 0.3,
        ease: "power2.inOut"
      })
      .to(".logo", {
        rotation: -10,
        duration: 0.3,
        ease: "power2.inOut"
      })
      .to(".logo", {
        rotation: 0,
        duration: 0.2,
        ease: "power2.inOut"
      })
      // Animate the heading, subheading, and paragraphs as before
      .from(".heading", { y: 80, opacity: 0 }, "-=0.5")
      .from(".subheading", { y: 60, opacity: 0 }, "-=0.5")
      .from(".paragraph", { y: 40, opacity: 0, stagger: 0.2 }, "-=0.4");

      // Start a continuous glow effect on the logo after the initial animations
      gsap.to(".logo", {
        duration: 1.5,
        filter: "drop-shadow(0 0 30px rgba(0,255,255,0.9))",
        repeat: -1,
        yoyo: true,
        ease: "power1.inOut"
      });
    }, bannerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={bannerRef}
      style={{
        width: "100%",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        backgroundColor: "#000" // Black background
      }}
    >
      {/* Logo */}
      <div
        style={{
          width: "100%",
          maxWidth: "600px",
          marginBottom: "1.5rem",
          marginTop: "3.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <img
          src="/GABS-Logo-2.png"
          alt="GABS Logo"
          className="logo"
          style={{
            width: "100%",
            height: "auto",
            filter: "drop-shadow(0 0 20px rgba(0, 255, 255, 0.6))"
          }}
        />
      </div>

      {/* Heading */}
      <h1
        className="heading"
        style={{
          fontSize: "2rem",
          marginBottom: "1rem",
          textAlign: "center",
          color: "#fff",
          textTransform: "uppercase",
          letterSpacing: "3px",
          textShadow: "0 0 5px rgba(255, 255, 255, 0.5)"
        }}
      >
        Ihr Partner für Präzision und Innovation für Bohrwerkzeuge 
      </h1>

      {/* Subheading */}
      <h2
        className="subheading"
        style={{
          fontSize: "1.2rem",
          marginBottom: "1.5rem",
          textAlign: "center",
          color: "#47b9bb", // Themed color
          letterSpacing: "1px",
          textShadow: "0 0 3px rgba(255, 255, 255, 0.3)"
        }}
      >
        Über ein Jahrhundert Erfahrung &amp; Know-how
      </h2>

      {/* Paragraph 1 */}
      <p
        className="paragraph"
        style={{
          maxWidth: "800px",
          marginBottom: "1rem",
          textAlign: "center",
          lineHeight: 1.6,
          color: "#eee",
          fontSize: "1rem",
          textShadow: "0 0 2px rgba(255, 255, 255, 0.2)"
        }}
      >
        Seit über einem Jahrhundert steht Heidenau für Qualität und Expertise in der Fertigung von Ausrüstungen für die Bohrindustrie. Dieses einzigartige Know-how wurde über Generationen hinweg kontinuierlich bewahrt und weiterentwickelt.
      </p>

      {/* Paragraph 2 */}
      <p
        className="paragraph"
        style={{
          maxWidth: "800px",
          marginBottom: "1rem",
          textAlign: "center",
          lineHeight: 1.6,
          color: "#eee",
          fontSize: "1rem",
          textShadow: "0 0 2px rgba(255, 255, 255, 0.2)"
        }}
      >
        Mit der Gründung der G-A-B-S GmbH im Jahr 2004 haben wir es geschafft, Tradition und Zukunft miteinander zu verbinden. Unser erfahrenes und engagiertes Team setzt die bewährten Techniken fort und entwickelt sie stetig weiter, um den Anforderungen der modernen Industrie gerecht zu werden.
      </p>
    </section>
  );
};

export default Banner;
